export const addPageIndexAttribute = (element: HTMLElement, pageIndex: string) => {
  element.setAttribute('page', pageIndex);
  element.parentElement.parentElement.setAttribute('page', pageIndex);
};
